import React, { useState } from 'react';
import { Button, Input } from "antd";
import {observer} from "mobx-react-lite";
import { authModel } from "../../entities/auth";
import "./LoginPage.scss";

const inputs = [
  {key: 'email', type: 'text', placeholder: 'Телефон или почта', Component: Input},
  {key: 'password', type: 'text', placeholder: 'Введите пароль', Component: Input.Password}
]

export const LoginPage = observer(() => {
  const [formInfo, setFormInfo] = useState({
    email: '',
    password: ''
  })

  const handleInputChange = (e) => {
    const {name, value} = e.target
    setFormInfo({...formInfo, [name]: value})
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    await authModel.login(formInfo.email, formInfo.password)
  }

  return (
    <div className='login-page'>

      <div className="login-page__image">
        <img src={require('../../shared/images/loginPage.png')} alt="img"/>
      </div>

      <form className='login-page__form' onSubmit={onSubmit}>
        {inputs.map(input => (
          <input.Component
            key={input.key}
            name={input.key}
            type={input.type}
            placeholder={input.placeholder}
            value={formInfo[input.key]}
            onChange={handleInputChange}
          />
        ))}
        <Button type="primary" htmlType="submit">
          Войти
        </Button>
      </form>
    </div>
  );
})
